import PrimeTooltip from 'primevue/tooltip'

const originalUpdated = (PrimeTooltip as any).updated

const getTarget = (el: HTMLElement): HTMLElement => {
  if (el.classList.contains('p-inputwrapper')) {
    return el.querySelector('input') || el
  }
  return el
}

const getValue = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value
  if (value && typeof value === 'object' && 'value' in value) {
    return (value as any).value
  }
  return undefined
}

;(PrimeTooltip as any).updated = function (
  el: HTMLElement,
  binding: any,
  vnode: any,
  prevVnode: any,
) {
  const target = getTarget(el)
  const oldValue = (target as any).$_ptooltipValue
  const oldDisabled = (target as any).$_ptooltipDisabled

  const newValue = getValue(binding.value)
  let newDisabled = false
  if (binding.value && typeof binding.value === 'object') {
    newDisabled = !!binding.value.disabled
  }

  if (oldValue === newValue && oldDisabled === newDisabled) {
    return
  }

  return originalUpdated.call(this, el, binding, vnode, prevVnode)
}
